package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import com.schoolconnect.app.repository.systemlookup.SystemLookupOptions

@Serializable
data class NoticeCreateRequest(
    @SerialName("school_id") val schoolId: String,
    val title: String,
    val content: String,
    @SerialName("notice_id") val noticeId: String? = null,
    val audience: String? = null,
    @SerialName("class_targets") val classTargets: List<String>? = null,
    @SerialName("expires_at") val expiresAt: String? = null,
    /** API values: DRAFT, PUBLISHED, or ARCHIVED. */
    val status: String = SystemLookupOptions.codes("NOTICE_STATUS").firstOrNull().orEmpty(),
    val id: String? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String> = emptyList()
)

@Serializable
data class NoticeUpdateRequest(
    val title: String? = null,
    val content: String? = null,
    val audience: String? = null,
    @SerialName("class_targets") val classTargets: List<String>? = null,
    @SerialName("expires_at") val expiresAt: String? = null,
    val status: String? = null,
    @SerialName("is_active") val isActive: Boolean? = null,
    @SerialName("attachment_file_ids") val attachmentFileIds: List<String>? = null
)
